/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/restrict-template-expressions */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/strict-boolean-expressions */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useState } from 'react'
import GradientButton from '../MUICustomButton/GradientButton'
import CustomDataTable from '../CustomDataTable/CustomDataTable'
import type { TableColumn } from 'react-data-table-component'
import MUIModal from '../MUIModal/MUIModal'
import AddClientForm from './AddClientForm'
import type { Client, ClientApiResponse } from '../types/types'
import { getAllClientData } from 'src/services/clientService'
import { Link, useNavigate } from 'react-router-dom'
import { Divider, Typography } from '@mui/material'
import { checkEventPermission } from 'src/common/utility/utility'




interface PropsType {
    parentId?: string;
}

function SubClientList({parentId} : PropsType): JSX.Element {

    const [loading, setLoading] = useState<boolean>(false)
    const [clientListData, setClientListData] = useState<Client[]>([])
    const [clientSearchData, setClientSearchData] = useState<Client[]>([])
    const [openAddClientModal, setOpenAddClientModal] = useState<boolean>(false)

    const navigate = useNavigate()
  
  
    useEffect(() => {
      getClientData()
    }, [parentId])
  
    const getClientData = (): void => {
      setLoading(true)
      getAllClientData()
      .then(
        (res: ClientApiResponse) => {
          if (res.status === 200) {
            if(res.data.result === 1) {
              const clientArr:any = [];
              res.data.data.map((data:any) => {
                if(parentId !== undefined && parseInt(data.parentId) === parseInt(parentId)) {
                  clientArr.push(data)
                }
              })
              setClientListData(clientArr)
              setClientSearchData(clientArr)
            }
            
          }
        }
      ) 
      .catch (
        error => console.log("Error: ", error)
      )
      .finally(() => {
        setLoading(false)
      })
    }
  
    const handleRefreshPage = (): void => {
      getClientData();
      handleCloseAddClientModal()
    }
  
    
  
    const handleAddClientClick = (): void => {
      // setOpenAddClientModal(true)
      // setLoading(false)
      navigate(`/settings/manage-clients/add-client/${parentId}`)
    }
  
    const handleCloseAddClientModal = (): void => {
      setOpenAddClientModal(false)
    }
  
    const handleSearch = (e: React.ChangeEvent<HTMLInputElement>): void => {
      const { value } = e.target;
      let clientDataArr = [...clientListData]
      if (value !== "") {
        // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions, @typescript-eslint/prefer-optional-chain
        clientDataArr = clientDataArr && clientDataArr.filter((client: Client) => {
          return client.clientName.toLowerCase().search(value.toLowerCase()) >= 0
        })
      }
  
      setClientSearchData(clientDataArr)
    }
  
    const columns: TableColumn<any>[] = [
      {
        name: 'Sub-client Name',
        selector: (row:any) => row.clientName,
        width: '25%',
        sortable: true
      },
      {
        name: 'Sub-client Contact',
        sortable: true,
        selector: (row: any) => row.clientContact,
        width: '20%',
        cell: (row: any) => <span>{row.clientContact}</span>
      },
      {
        name: 'Email',
        sortable: true,
        width: '25%',
        selector: (row: any) => row.email,
        cell: (row: any) => <span>{row.email}</span>
      },
      {
        name: 'Status',
        sortable: false,
        width: "18%",
        // selector: row => row.year,
        cell: (row: any) => {
          return row.isActive ? <div className="badge truncate" style={{
            background: '#CCFFEA',
            padding: '10px 15px',
            color: '#06A864',
            border: '0px'
          }}>Active</div> : <div className="badge truncate" style={{
            background: '#FFF5F6',
            padding: '10px 15px',
            color: '#F13139',
            border: '0px'
          }}>Inactive</div>
        }
      },
      {
        name: 'Actions',
        sortable: false,
        id: 'action',
        width: "7%",
        style: {
          display: 'flex',
          justifyContent: 'flex-start'
        },
        // selector: row => row.year,
        cell: (row: any) => {
          return (
            <div className='flex items-center'>
              <div className="icon-hover-container">
              <Link to={`/settings/manage-clients/edit/${row.id}`} state={{clientData: row}} style={{ width: '20px' }}>
                <img src={'/assets/images/icons/EditIcon.svg'} width={20} height={20} alt="" />
              </Link>
              </div>
            </div>
          )
        }
      },
    ]
  
    return (
      <React.Fragment>
        <Typography variant="h6" gutterBottom sx={{ color: '#3A3A3A', fontSize: '16px', fontWeight: '600', marginBottom: '10px' }}>
          Sub-clients
        </Typography>
        <Divider sx={{ color: '#D9D9D9', marginBottom: '10px' }} />
        <div className="flex my-5 gap-x-2 justify-between items-center">
          <div className="basis-3/5">
            <div className="form-control">
              <input type="text" placeholder="Search Sub-client" className="input input-bordered w-auto search-input-white focus:ring-0 focus:outline-none focus:border-primary font-normal text-14 text-muted" onChange={handleSearch} />
            </div>
          </div>
          <div className="basis-2/5 justify-end flex">
  {(checkEventPermission("CLIENTS_ADD") || checkEventPermission("CLIENTS_UPDATE") )&&
            <GradientButton color='red' onClick={handleAddClientClick}>
              <span style={{
                width: "20px",
                height: "20px",
                background: "#fff",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                borderRadius: "50px",
                marginRight: "5px"
              }}>
                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="19" viewBox="0 0 19 19" fill="none">
                  <path d="M17.5411 10.3185H1.03183C0.467764 10.3185 0 9.85078 0 9.28671C0 8.72265 0.467764 8.25488 1.03183 8.25488H17.5411C18.1052 8.25488 18.573 8.72265 18.573 9.28671C18.573 9.85078 18.1052 10.3185 17.5411 10.3185Z" fill="#F13139" />
                  <path d="M9.28671 18.573C8.72265 18.573 8.25488 18.1052 8.25488 17.5411V1.03183C8.25488 0.467764 8.72265 0 9.28671 0C9.85078 0 10.3185 0.467764 10.3185 1.03183V17.5411C10.3185 18.1052 9.85078 18.573 9.28671 18.573Z" fill="#F13139" />
                </svg>
              </span>
              Add New Sub-client
            </GradientButton>
            }
          </div>
        </div>
        <div className='data-table-container mb-10'>
        <CustomDataTable
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            columns={columns}
            data={clientSearchData.length > 0 ? clientSearchData : []}
            pagination
            selectableRows
            progressPending={loading}
          />
        </div>
        {/* <MUIModal title='Add Sub-client' openModal={openAddClientModal} closeModal={handleCloseAddClientModal} width={'25%'} >
              <AddClientForm closeModal={handleCloseAddClientModal} refreshPage={handleRefreshPage} parentId={parentId}/>
        </MUIModal> */}
  
        
      </React.Fragment>
    )
}

export default SubClientList